import React from "react";

const ST = {
  accepted: { bg: "#dcfce7", c: "#16a34a", dot: "#16a34a", l: "Accepted" },
  pending:  { bg: "#fef3c7", c: "#d97706", dot: "#d97706", l: "Pending"  },
  rejected: { bg: "#fee2e2", c: "#dc2626", dot: "#dc2626", l: "Rejected" },
  draft:    { bg: "#f1f5f9", c: "#64748b", dot: "#94a3b8", l: "Draft"    },
};

const Badge = ({ status }) => {
  const s = ST[String(status || "").toLowerCase()] || ST.pending;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        fontSize: 10,
        fontWeight: 700,
        padding: "3px 9px",
        borderRadius: 20,
        letterSpacing: ".04em",
        textTransform: "uppercase",
        fontFamily: "var(--fm)",
        background: s.bg,
        color: s.c,
        whiteSpace: "nowrap",
      }}
    >
      <span
        style={{
          width: 5,
          height: 5,
          borderRadius: "50%",
          background: s.dot,
          flexShrink: 0,
          display: "inline-block",
        }}
      />
      {s.l}
    </span>
  );
};

export default Badge;
